import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storage = localStorage;

  public get(key, parse = true) {
    return parse ? JSON.parse(this.storage.getItem(key)) : this.storage.getItem(key);
  }

  public getIfExists(key, defaultValue) {
    const item = this.get(key);
    return item !== null && item !== '' ? item : defaultValue;
  }

  public set(key, data) {
    this.storage.setItem(key, JSON.stringify(data));
  }

  public delete(key) {
    this.storage.removeItem(key);
  }

  public isEmpty(key) {
    const item = this.get(key, false);
    return item === null || item === '';
  }
}
